<template>
  <div>
    <!-- 地理图容器 -->
    <div ref="chart" class="chart" :style="{width, height}"></div>
  </div>
</template>
<script>
// echarts
import echarts from "echarts";
// 世界地图数据
import world from "echarts/map/json/world.json";
export default {
  name: "echarMap",
  props: {
    mapData: {
      type: Array,
      default: [],
    },
    minData: {
      type: Number,
      default: 0,
    },
    maxData: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },    
  },
  data() {
    return {
      chart: null,
      resizeHandler: null,
      // ........................
      // 此处不支持变量！（默认浅色）
      visualMapInRangeColor : [
        // [@primary95：深rgba(,1)|浅#BAFFDE]
        // 暂不考虑换肤
        "#BAFFDE",
        "#6CDBAC",
        "#2DA378",
        "#006C4A",
        "#003824",
      ],
      // [@green:深#73DD82|浅#47A354]
      seriesItemStyleEmphasisAareaColor: "#47A354",
      // [@reverseBaseColor:深rgba(255,255,255,0.6)|浅rgba(0,0,0,0.6)]
      visualMapTextStyleColor: "rgba(0,0,0,0.6)",
      // ........................
    };
  },
  created(){
    // [创建vue实例时]获取当前模式与主题下的地图颜色系列
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy () {
    // 移除自适应监听
    window.removeEventListener('resize', this.resizeHandler)
    this.resizeHandler = null
  },
  watch: {
    options: {
      handler () {
        this.refresh()
      },
      deep: true,
    },
    // 响应更新换肤事件
    "$store.state.event.updateSkin9"(val) {
      if (val) {
        // console.log("刷新本页");
        location.reload();
        // ....................................
        // true深色 | false 浅色
        let tmpMode =
          String(localStorage.getItem("modeFlag")) == "true" ? true : false;
        // 各种主题色
        let tmpThemeColor = localStorage.getItem("themeColorFlag") || "mt-blue";
        // ....................................
        // 一个项目一个主题色，仅做深浅模式切换
        // 深-蓝
        if(tmpMode&&tmpThemeColor=='mt-blue'){
          // [@green:深#73DD82|浅#47A354]
          this.seriesItemStyleEmphasisAareaColor = "#73DD82";
          // [@reverseBaseColor:深rgba(255,255,255,0.6)|浅rgba(0,0,0,0.6)]
          this.visualMapTextStyleColor = "rgba(255,255,255,0.6)";
        }
        // 浅-蓝
        if(!tmpMode&&tmpThemeColor=='mt-blue'){
          // [@green:深#73DD82|浅#47A354]
          this.seriesItemStyleEmphasisAareaColor = "#47A354";
          // [@reverseBaseColor:深rgba(255,255,255,0.6)|浅rgba(0,0,0,0.6)]
          this.visualMapTextStyleColor = "rgba(0,0,0,0.6)";
        }
        // ....................................
        // 重置该事件状态
        this.$store.state.event.updateSkin9 = false;
      }
    },
  },
  computed: {
    options() {
      // 布局
      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          bottom: "70"
        }, ...this.grid
      };
      return {
        // 标题
        title: {
          show: false,
        },
        // 工具条
        toolbox: {
          show: false,
        },
        // 布局
        grid,
        // 悬浮框
        tooltip: {
          show: false,
          // trigger: "item",
          // showDelay: 0,
          // transitionDuration: 0.2,
        },
        // visualMap
        visualMap: {
          // 控制器位置
          left: "24",
          bottom: "0",
          // 控制器朝向
          // (horizontal水平，vertical垂直)
          orient : 'horizontal',
          // 最小值
          min: this.minData,
          // 最大值
          max: this.maxData,
          // 文本（默认为数值文本）
          // text: ["High", "Low"],
          text: ["", ""], 
          calculable: true,
          // 地图着色
          inRange: { 
            // [换肤]
            color: this.visualMapInRangeColor,
          },
          // 控制器尺寸
          // （注意：水平时，width为垂直方向，height为水平方向）
          // 7*202
          itemWidth: 7,
          itemHeight: "100%",
          // 控制器样式
          controller: {
            inRange: {
              // 控制器内部着色
              color: [
                "#BAFFDE",
                "#6CDBAC",
                "#2DA378",
                "#006C4A",
                "#003824",
              ],
              symbol: ['roundRect'],
              symbolSize: [20, 20],
            },
            outOfRange: {
              color: ["#aaa"],
              symbol: ['roundRect'],
              symbolSize: [20, 20],
            }
          },
          // 文字样式
          textStyle: {
            // [@reverseBaseColor:深rgba(255,255,255,0.6)|浅rgba(0,0,0,0.6)]
            color: this.visualMapTextStyleColor,
          }
        },
        // 系列
        series: [
          {
            name: "",
            type: "map",
            map: "world",
            // 禁止缩放
            roam: false,
            // 初始比例
            zoom: "1",
            // 地图位置
            top: "10",
            itemStyle: {
              normal: {
                // 标签
                label: {
                  show: false,
                  // 默认字色
                  // color: 'red',
                },
                // 默认面积色
                areaColor: '#F3FFF7',
                // 默认面积边框尺寸
                borderWidth: 1,
                // 默认面积边框颜色
                borderColor: '#fff' ,
              },
              emphasis: {
                label: {
                  show: false,
                  // 悬浮字色
                  // color: 'blue',
                },
                // 悬浮面积色
                // [@green:深#73DD82|浅#47A354]
                areaColor: this.seriesItemStyleEmphasisAareaColor,
              }
            },
            // 数据
            data: this.mapData,
          }
        ]
      };
    }
  },
  methods: {
    initMap() {
      // 注册地图
      echarts.registerMap("world", world);
      // 地图初始化
      let dom = this.$refs.chart;
      this.chart = echarts.init(dom);
      this.chart.clear();
      // 传参
      this.chart.setOption(this.options);
      // ......................................
      // 地图点击事件
      // ...........
      // let vm = this;
      // myChart.on("click", function(params) {
      //   console.log(params);
      //   if (params.name === "China") {
      //     console.log(1111);
      //     // vm.setEcs(vm.check);
      //   }
      // });
      // ......................................
      // 监听并上报图表事件
      this.chart.on('mouseover', param => {
        this.$emit('over', param);
      });
      this.chart.on('mouseout', param => {
        this.$emit('out', param);
      });
      this.chart.on('click', param => {
        this.$emit('click', param);
      });

      // 窗口尺寸变化时自适应
      this.resizeHandler = () => {
        this.chart.resize();
      };
      window.addEventListener('resize', this.resizeHandler);
      // ......................................
    },
    // 数据更新
    refresh () {
      this.chart && this.chart.setOption(this.options);
    },
  }
};
</script>
<style lang="less" scoped>
</style>


